var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeypadButtonsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.44,
    cy: 14.95,
    r: 10.2,
    transform: "translate(-2.76 6.24) rotate(-13.28)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.54,
    cy: 14.95,
    r: 10.2,
    transform: "translate(3.94 39.41) rotate(-45)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.58,
    cy: 14.95,
    r: 10.2,
    transform: "translate(-1.47 17.31) rotate(-13.28)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.44,
    cy: 38.95,
    r: 10.2,
    transform: "translate(-8.27 6.89) rotate(-13.28)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.54,
    cy: 38.95,
    r: 10.2,
    transform: "translate(-13.03 46.44) rotate(-45)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.58,
    cy: 38.95,
    r: 10.2,
    transform: "translate(-6.98 17.95) rotate(-13.28)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.44,
    cy: 62.95,
    r: 10.2,
    transform: "translate(-13.78 7.53) rotate(-13.28)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.54,
    cy: 62.95,
    r: 10.2,
    transform: "translate(-30 53.47) rotate(-45)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.58,
    cy: 62.95,
    r: 10.2,
    transform: "translate(-12.49 18.59) rotate(-13.28)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.54,
    cy: 86.95,
    r: 10.2,
    transform: "translate(-46.97 60.5) rotate(-45)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypadButtonsIcon);
export default __webpack_public_path__ + "static/media/keypad-buttons-icon.26b4347a9de14681c4fe22b1428ebbd1.svg";
export { ForwardRef as ReactComponent };